import './flight-filters.scss';
import FlightFiltersService from './flight-filters-service';

const MODULE_NAME = 'app.flights.flight-filters';
const module = angular.module(MODULE_NAME, [])
    .service(FlightFiltersService.SERVICE_NAME, FlightFiltersService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/filters/flight-filters-module.js